export enum GTM_CUSTOM_EVENTS {
    AppReady = 'AppReady',
    None = 'None'
}

export class GtmInitialize {
    constructor(
        public event: GTM_CUSTOM_EVENTS,
        public user_id: string,
        public user_email: string,
        public user_fullname: string,
        public user_type: string
    ) {}
}
